import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Search } from "lucide-react";
import type { FiltroAvaliacaoAgencia } from "@/types/avaliacao";

interface AvaliacaoAgenciaFiltersProps {
  filtro: FiltroAvaliacaoAgencia;
  onChange: (filtro: FiltroAvaliacaoAgencia) => void;
  buscaNome: string;
  onBuscaNomeChange: (value: string) => void;
  buscaNucleo: string;
  onBuscaNucleoChange: (value: string) => void;
  totalNaoAvaliadas: number;
}

export function AvaliacaoAgenciaFilters({
  filtro,
  onChange,
  buscaNome,
  onBuscaNomeChange,
  buscaNucleo,
  onBuscaNucleoChange,
  totalNaoAvaliadas,
}: AvaliacaoAgenciaFiltersProps) {
  return (
    <div className="space-y-3">
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Buscar por nome do freelancer..."
            value={buscaNome}
            onChange={(e) => onBuscaNomeChange(e.target.value)}
            className="pl-9"
          />
        </div>
        <div className="relative flex-1">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Buscar por núcleo..."
            value={buscaNucleo}
            onChange={(e) => onBuscaNucleoChange(e.target.value)}
            className="pl-9"
          />
        </div>
      </div>
      <ToggleGroup
        type="single"
        value={filtro}
        onValueChange={(value) => {
          if (value) onChange(value as FiltroAvaliacaoAgencia);
        }}
        className="justify-start"
      >
        <ToggleGroupItem value="todas" aria-label="Todas">
          Todas
        </ToggleGroupItem>
        <ToggleGroupItem value="avaliadas" aria-label="Avaliadas">
          Avaliadas
        </ToggleGroupItem>
        <ToggleGroupItem value="nao_avaliadas" aria-label="Não avaliadas" className="gap-1.5">
          Não avaliadas
          {totalNaoAvaliadas > 0 && (
            <Badge variant="destructive" className="h-5 min-w-[20px] px-1.5 text-[10px] font-bold">
              {totalNaoAvaliadas}
            </Badge>
          )}
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}
